var map = {
	"./components/home/dashboard/widgets/ButtonWidget/settings.vue": [
		"a356",
		"chunk-2d207f09"
	],
	"./components/home/dashboard/widgets/TextWidget/settings.vue": [
		"778e",
		"chunk-2d0d7703"
	],
	"./components/home/dashboard/widgets/VQBCellWidget/settings.vue": [
		"71a3",
		"chunk-6540905a"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/charts/line/settings.vue": [
		"e3f8",
		"chunk-6e24e3c2"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/charts/pie/settings.vue": [
		"d697",
		"chunk-6bfc3f8f"
	],
	"./components/home/dashboard/widgets/VQBChartWidget/settings.vue": [
		"5a49",
		"chunk-d593d5ec"
	],
	"./components/home/dashboard/widgets/VQBTableWidget/settings.vue": [
		"7763",
		"chunk-043909c6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "74e8";
module.exports = webpackAsyncContext;